import { Button } from 'shared-ui';

import { ReactComponent as ArchiveIcon } from 'assets/icons/archive-primary.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';
import { ActionModal } from 'ui/actionModal/ActionModal';

import { UnarchiveMultiGlcProps } from './UnarchiveMultiGlc.types';

export const UnarchiveMultiGlc = ({
  checkedGlc,
  isModalOpen,
  onSubmit,
  isLoading,
  onModalClose,
  onModalOpen,
}: UnarchiveMultiGlcProps) => {
  const { formatMessage } = useLocale();

  return (
    <>
      <Button variant="outlined" color="primary" size="medium" startIcon={<ArchiveIcon />} onClick={onModalOpen}>
        {formatMessage({ id: AppMessages['glc.multiAction.unarchive.button'] })}
      </Button>
      <ActionModal
        header={formatMessage({ id: AppMessages['glc.multiAction.unarchive.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        onSubmit={onSubmit}
        isLoading={isLoading}
        submitButtonText={formatMessage({ id: AppMessages['glc.multiAction.unarchive.button'] })}
      >
        <ActionModal.Subtitle>
          {formatMessage({ id: AppMessages['glc.multiAction.unarchive.subtitle'] })} {checkedGlc.length}
        </ActionModal.Subtitle>

        <ActionModal.Text>{formatMessage({ id: AppMessages['glc.multiAction.unarchive.text'] })}</ActionModal.Text>
      </ActionModal>
    </>
  );
};
